// extracted by mini-css-extract-plugin
module.exports = {"mark":"LocalHeroMark_mark__B430v"};